import React, { useEffect, useRef, useState } from "react";
import { SendPostRequest } from "../../../http";
import { Link } from "react-router-dom";
import Spinner from "../../Spinner";
import { limitParagraphByCharLimit } from "../../../Helper/Helper";

const animationList = ["fadeInLeft", "fadeInRight"];

function TimelineBlogsList() {
  const timelineSectionRef = useRef(null);
  const [blogsData, setBlogsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hasData, setHasData] = useState(false);

  useEffect(() => {
    getBlogsData();
  }, []);

  const getBlogsData = async () => {
    try {
      setLoading(true);
      const response = await SendPostRequest("blogs/list");
      const data = response?.data || [];
      setBlogsData(data);
      setHasData(data.length > 0);
    } catch (error) {
      console.error("Error fetching blogs:", error);
      setBlogsData([]);
      setHasData(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!hasData) return;

    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const animatedItems = entry.target.querySelectorAll("li.animated");
          animatedItems.forEach((item, index) => {
            setTimeout(() => {
              const animationType = item.getAttribute("data-animation");
              if (
                animationType === "fadeInLeft" &&
                !item.classList.contains("visible")
              ) {
                item.classList.add("fadeInLeft", "visible");
              } else if (
                animationType === "fadeInRight" &&
                !item.classList.contains("visible")
              ) {
                item.classList.add("fadeInRight", "visible");
              }
            }, index * 300);
          });
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      threshold: 0.1,
    });

    if (timelineSectionRef.current) {
      observer.observe(timelineSectionRef.current);
    }

    return () => {
      if (timelineSectionRef.current) {
        observer.unobserve(timelineSectionRef.current);
      }
    };
  }, [hasData, blogsData]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "300px" }}>
        <Spinner />
      </div>
    );
  }
  if (!hasData) return null;

  return (
    <section
      id="facilities-section"
      className="timeline-section pad-bottom-70"
      ref={timelineSectionRef}
    >
      <div className="container">
        <div className="row">
          <div className="offset-md-2 col-md-8">
            <div className="title-wrap text-center">
              <div className="section-title margin-bottom-60">
                <h2 className="section-title margin-top-5 mb-0 text-uppercase">
                Blogs
                </h2>
                <span className="section-border-bottom center"></span>
              </div>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="timeline-wrapper">
              <ul className="timeline">
                {blogsData?.slice(0, 5)?.map((data, index) => (
                  <li
                    key={index}
                    className={`mb-5 animated ${index % 2 === 1 ? "timeline-inverted" : ""

                      }`}
                    data-animation={animationList[index % 2]}
                    style={{ minHeight: "200px" }}
                  >
                    <div className="timeline-image">
                      <div
                        className="img-circle first-fservices-img-wrapper"
                        style={{
                          backgroundImage: `url(${data?.image || "/assets/images/default.jpg"})`,
                        }}
                      />
                    </div>
                    <div className="timeline-panel">
                      <Link
                        to={`/blog/detail/${data?.slug}`}
                      >
                        <div className="timeline-heading">
                          <h4 className="timeline-title text-uppercase first-fservices-title" style={{fontSize:"19px", lineHeight:"28px"}}>
                            {data?.title}
                          </h4>
                        </div>
                        <div
                          className="timeline-body text-black"
                          dangerouslySetInnerHTML={{
                            __html:
                              limitParagraphByCharLimit(
                                data?.short_content || data?.content || "",
                                190
                              ) +
                              ((data?.short_content || data?.content || "").length > 190 ? "..." : ""),
                          }}
                        />

                      </Link>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TimelineBlogsList;